module.exports = __webpack_public_path__ + "static/media/1.fdb06380.svg";